import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Ranger extends PositionedGoodyHOC {

	render() {
		const style = {
			st40: {
				fill: '#D1AF79',
			},
			st157: {
				fill: '#CEA365',
			},
			st24: {
				fill: '#5E5E5E',
			},
		};

		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="71.0000153" cy="56.2328835" />
				<path style={style.st40} d="M108.6850586,37.5460205v-6.7702637c0-3.8115234-1.7114258-7.4216309-4.6618652-9.8347168
					L82.4348145,3.2872314c-2.2692871-1.8557129-5.1105957-2.8693848-8.0422363-2.8693848H71h-3.3925781
					c-2.9316406,0-5.7729492,1.013916-8.0422363,2.8693848L37.9769287,20.94104
					c-2.9505615,2.4130859-4.6619873,6.0231934-4.6619873,9.8347168v6.7702637
					c-20.2653809,2.2805176-33.0983887,6.3823242-33.0983887,11.064209v1.0007324
					c0,7.1638184,30.0327148,12.9711914,70.7834473,12.9711914s70.7834473-5.807373,70.7834473-12.9711914v-1.0007324
					C141.7834473,43.9283447,128.9504395,39.8267822,108.6850586,37.5460205z" />
				<circle style={style.st157} cx="71.0000153" cy="28.0129185" r="2" />
				<circle style={style.st157} cx="66.9968109" cy="34.6384544" r="2" />
				<circle style={style.st157} cx="75.003212" cy="34.6384544" r="2" />
				<path style={style.st157} d="M55.4376221,21.4908447c5.2414551-4.3552246,7.4835205-11.7021484,7.6231689-20.2216797
					c-1.2556152,0.4814453-2.439209,1.1542969-3.4956055,2.0180664L47.0039062,13.5592041
					c-3.1057129,2.5637207-6.1898193,5.0942383-9.2636719,7.5986328c-1.4025879,1.2075195-2.5109863,2.6865234-3.2651367,4.3337402
					C37.335083,27.0640869,45.2526855,29.9537354,55.4376221,21.4908447z" />
				<path style={style.st157} d="M104.2596436,21.1578369c-3.0726318-2.503418-6.1555176-5.0332031-9.2601318-7.5957031
					L82.4348145,3.2872314c-1.0563965-0.8637695-2.2398682-1.536377-3.4954834-2.0180664
					c0.1395264,8.5195312,2.3817139,15.8664551,7.6231689,20.2216797c10.1848145,8.4628906,18.1025391,5.5732422,20.9624023,4.0007324
					C106.770874,23.8443604,105.6623535,22.3653564,104.2596436,21.1578369z" />
				<path style={style.st24} d="M33.9196777,41.7418213l-0.6047363-0.1062012v7.0993652
					c2.8123779,0.4389648,15.3067627,2.1674805,37.6848145,2.1674805c22.3778076,0,34.8723145-1.7282715,37.6853027-2.1674805
					v-7.0986328l-0.6022949,0.1049805c-0.1240234,0.0214844-12.6953125,2.1611328-37.0830078,2.1611328
					C46.7155762,43.9024658,34.1481934,41.7808838,33.9196777,41.7418213z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Ranger.js